import { UserAgentChecker } from "booking_app/utils/user-agent-checker";

export class HeaderBannerController {

  static $inject = [
    "UserAgentChecker",
    "$scope",
  ];

  public bannerDescription: boolean;
  public mobileEventListener: () => void;

  constructor(
    private userAgentChecker: UserAgentChecker,
    private $scope: any,
  ) { }

  $onInit(): void {
    this.bannerDescription = false;
    this.mobileEventListener = (): void => {
      this.showBanner(false);
      this.$scope.$apply();
    };
  }

  public isMobile(): boolean {
    return this.userAgentChecker.isMobileOrTablet();
  }

  public showBanner(status?: boolean): void {
    this.bannerDescription = status || !this.bannerDescription;
    if (this.isMobile()) {
      if (this.bannerDescription) {
        window.addEventListener("scroll", this.mobileEventListener);
      } else {
        window.removeEventListener("scroll", this.mobileEventListener);
      }
    }
  }
}
